import styles from "./PageBlockDialog.module.css"
import Dialog from '../dialogs/Dialog';
import { ReactComponent as RowIcon } from '../../assets/images/icons/ic-rows.svg';
import { ReactComponent as ColumnIcon } from '../../assets/images/icons/ic-columns.svg';
import { ReactComponent as TextIcon } from '../../assets/images/icons/ic-text.svg';
import { ReactComponent as TextEditorIcon } from '../../assets/images/icons/ic-text-editor.svg';
import { ReactComponent as ImageIcon } from '../../assets/images/icons/ic-image.svg';
import { ReactComponent as VideoIcon } from '../../assets/images/icons/ic-lessons-active.svg';
import { ReactComponent as ButtonIcon } from '../../assets/images/icons/ic-click.svg';
import { ReactComponent as CarouselIcon } from '../../assets/images/icons/ic-careers-active.svg'
import { ReactComponent as BookIcon } from '../../assets/images/icons/ic-book-active.svg'
import { ReactComponent as ChevronIcon } from '../../assets/images/icons/ic-chevron.svg';
import { ReactComponent as IconsIcon } from '../../assets/images/icons/ic-icons.svg';
import { ReactComponent as QuestionIcon } from '../../assets/images/icons/ic-question-circle.svg';
import { ReactComponent as CodeIcon } from '../../assets/images/icons/ic-code.svg';
import { ReactComponent as FormIcon } from '../../assets/images/icons/ic-form.svg';

import { BlockType } from "../../common/constants";
import { Each } from "../../common/Each";
import api from "../../api";
import { useEffect, useState } from "react";
import TextInput from "../TextInput";
import { usePageBuilder } from "./PageBuilderContext";

const PageBlockDialog = ({ open, type, onClose = () => { }, onSelect = () => { }, onSelectTemplate = () => { } }) => {

    const [templates, setTemplates] = useState([]);
    const [total, setTotal] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const { selectedBlock } = usePageBuilder();

    const getTemplates = async () => {
        try {
            let path = '/admin/builder/templates?page=0&per=100';
            if (searchQuery && searchQuery !== '') {
                path += `&q=${encodeURIComponent(searchQuery)}`;
            }
            const response = await api.get(path);
            setTemplates(response.items);
            setTotal(response.total);
        }
        catch (error) {
            console.error("Error fetching templates: ", error);
        }
    }

    useEffect(() => {
        if (open) {
            getTemplates();
        }
    }, [open, searchQuery]);

    const blocks = [
        // {
        //     type: 'text',
        //     element: <button
        //         className={styles.dialogBlockButton}
        //         onClick={() => onSelect('text')}>
        //         <TextIcon className={styles.dialogBlockIcon} />
        //         Testo
        //     </button>
        // },
        {
            type: 'markdown',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('markdown')}>
                <TextEditorIcon className={styles.dialogBlockIcon} />
                Markdown
            </button>
        },
        {
            type: 'column',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('column')}>
                <ColumnIcon className={styles.dialogBlockIcon} />
                Colonna
            </button>
        },
        {
            type: 'row',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('row')}>
                <RowIcon className={styles.dialogBlockIcon} />
                Riga
            </button>
        },
        {
            type: 'image',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('image')}>
                <ImageIcon className={styles.dialogBlockIcon} />
                Immagine
            </button>
        },
        {
            type: 'video',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('video')}>
                <VideoIcon className={styles.dialogBlockIcon} />
                Video
            </button>
        },
        {
            type: 'button',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('button')}>
                <ButtonIcon className={styles.dialogBlockIcon} />
                Bottone
            </button>
        },
        {
            type: 'editions',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('editions')}>
                <BookIcon className={styles.dialogBlockIcon} />
                Edizioni
            </button>
        },
        {
            type: 'collapsable',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('collapsable')}>
                <ChevronIcon className={styles.dialogBlockIcon} />
                Collapsable
            </button>
        },
        {
            type: 'carousel',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('carousel')}>
                <CarouselIcon className={styles.dialogBlockIcon} />
                Carousel
            </button>
        },
        {
            type: 'icon',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('icon')}>
                <IconsIcon className={styles.dialogBlockIcon} />
                Icon
            </button>
        },
        {
            type: 'faq',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('faq')}>
                <QuestionIcon className={styles.dialogBlockIcon} />
                FAQ
            </button>
        },
        {
            type: 'html',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('html')}>
                <CodeIcon className={styles.dialogBlockIcon} />
                HTML
            </button>
        },
        {
            type: 'form',
            element: <button
                className={styles.dialogBlockButton}
                onClick={() => onSelect('form')}>
                <FormIcon className={styles.dialogBlockIcon} />
                Form
            </button>
        }
    ]

    const getButtons = () => {
        switch (type) {
            case BlockType.Section:
            case BlockType.Collapsable:
            case BlockType.Carousel:
                return (
                    <Each of={blocks} render={(block) => {
                        return block.element
                    }} />
                );
            case BlockType.Column:
                return (
                    <Each of={blocks} render={(block) => {
                        if (block.type !== 'column') {
                            return block.element
                        }
                    }} />
                );
            case BlockType.Row:
                return (
                    <Each of={blocks} render={(block) => {
                        if (block.type !== 'row') {
                            return block.element
                        }
                    }} />
                );
            default:
                return <></>;
        }
    };

    const getTemplateButtonDisabled = (template) => {
        if (!selectedBlock) {
            if (template.content.type === BlockType.Section) {
                return false;
            }
            return true
        }
        else {
            if (selectedBlock.type === template.content.type && selectedBlock.type !== BlockType.Section) {
                return true;
            }
            if (![BlockType.Section, BlockType.Column, BlockType.Row, BlockType.Collapsable, BlockType.Carousel].includes(selectedBlock.type)) {
                return true;
            }
        }
    }

    const getTemplateTypeClass = (type) => {
        switch (type) {
            case BlockType.Section:
                return styles.section;
            case BlockType.Column:
                return styles.column;
            case BlockType.Row:
                return styles.row;
            case BlockType.Collapsable:
                return styles.collapsable;
            case BlockType.Carousel:
                return styles.carousel;
            default:
                return '';
        }
    }

    return (
        <Dialog open={open} onClose={onClose} title={"Aggiungi Elemento"} style={{ userSelect: 'none' }}>
            <div className={styles.title} style={{ paddingBottom: '0.5rem' }}>Blocchi ({total})</div>
            <div className={styles.blocks}>
                {getButtons()}
            </div>
            <div className={styles.templates}>
                <div className={styles.title}>Template ({total})</div>
                <TextInput type="search" placeholder="Cerca template..." onKeyUp={(value) => {
                    setSearchQuery(value);
                }} />
                <div className={styles.templatesList}>
                    <Each of={templates} render={(template) => {
                        return (
                            <button
                                key={template.id}
                                className={styles.templateButton}
                                disabled={getTemplateButtonDisabled(template)}
                                onClick={() => onSelectTemplate(template)}>
                                <div className={`${styles.templateType} ${getTemplateTypeClass(template.content?.type)}`}>{template.content?.type.toUpperCase()}</div>
                                {template.thumbnail ?
                                    <img src={template.thumbnail} alt={template.name} className={styles.templateThumbnail} />
                                    :
                                    <div className={styles.templateNoThumbnail}>No Preview</div>
                                }
                                <div className={styles.templateName}>{template.name}</div>
                            </button>
                        )
                    }} />
                </div>
            </div>
        </Dialog>
    )

}

export default PageBlockDialog;